import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function UndoDialog({open, close, confirm}) {

  const handleClose = () => {
    close();
  };

  const handleConfirm = () => {
    confirm();
  }

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        hideBackdrop={true}
        disableScrollLock
      >
        <DialogTitle id="alert-dialog-title">
          Undo Matches
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This will revert all matches to the previous set of matches and cannot be undone. 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleConfirm} autoFocus>
            Do it
          </Button>
        </DialogActions>
      </Dialog>
  );
}